import { UserRolesRequest } from '@app/models/user_roles/UserRolesRequest';
import {
  UserRolesResponse,
  UserRolesTableData,
  UserRolesTableRow,
  UserRoleApiData,
} from '@app/models/user_roles/UserRolesResponse';
import { Parameters } from '@app/models/Parameters';

import { post, get } from './http.api';

export const storeUserRole = async (userRoleData: UserRolesRequest) => {
  try {
    const response = await post<any>('roles/create', userRoleData, undefined, true);
    console.log(`Status: ${response.status}`, `Data: ${JSON.stringify(response.data)}`);
    return response.data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getUserRolesTableData = async (parameters: Parameters): Promise<UserRolesTableData> => {
  try {
    const { data, status } = await get<any>('roles', { params: parameters }, true);
    console.log(`Status: ${status}`, `Data:`, data);

    const roles: UserRolesTableRow[] = data.data.map((roleData: any) => ({
      id: roleData.id,
      role_name: roleData.role_name,
      description: roleData.description,
    }));

    return {
      data: roles,
      pagination: {
        current: data.current_page,
        pageSize: data.per_page,
        total: data.total,
      },
    };
  } catch (error: any) {
    console.error('Error fetching user roles:', error);
    throw error;
  }
};

export const getAllUserRoles = async (): Promise<UserRolesResponse> => {
  try {
    const { data, status } = await get<UserRolesResponse>(`roles`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const getUserRoleById = async (id: number): Promise<UserRolesResponse> => {
  try {
    const { data, status } = await get<UserRolesResponse>(`roles/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${JSON.stringify(data)}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw error;
  }
};

export const createUserRole = async (): Promise<UserRoleApiData> => {
  try {
    const { data, status } = await get<UserRoleApiData>(`roles/create`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const updateUserRole = async (id: number, UpdateRoleData: UserRolesRequest) => {
  try {
    const { data, status } = await post<UserRolesRequest>(`roles/${id}/edit`, UpdateRoleData, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const showUserRole = async (id: number) => {
  try {
    const { data, status } = await get<UserRoleApiData>(`roles/${id}`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};

export const editUserRole = async (id: number) => {
  try {
    const { data, status } = await get<UserRoleApiData>(`roles/${id}/edit`, undefined, true);
    console.log(`Status: ${status}`, `Data: ${data}`);
    return data;
  } catch (error: any) {
    console.error(`Error: ${error.status} - ${error.message}`);
    throw new Error(`Error: ${error.status} - ${error.message}`);
  }
};
